import "./nav.scss";
import hd4k from "../../assets/icons/hd-4k.svg";
import baseLogo from "../../assets/logos/logo-compressed.svg";
import { useState, useContext } from "react";

import Cart from "../Cart/Cart";
import { ShopContext } from "../../context/ShopContext";

function Nav({ products }) {
  const [openCart, setOpenCart] = useState(false);
  const { addToCart, removeFromCart, cartItems } = useContext(ShopContext);

  const getCartQty = () => {
    // adds total of cartItems quantities together
    let cartQty = Object.values(cartItems).reduce((a, b) => a + b, 0);
    return cartQty;
  };

  let cartQty = getCartQty();

  return (
    <>
      <nav className="nav-container">
        <ul className="nav-list">
          <li className="nav-list__item nav-logo">basement</li>
          <li className="nav-list__item nav-logo__small">
            <img
              className="nav-logo__img"
              src={baseLogo}
              alt="Lowercase B and period"
            />
          </li>
          <li className="nav-list__item nav-symbols">
            <img
              src={hd4k}
              alt="In order: Nuclear symbol, HD symbol, alternative eyeball, 4K symbol, Warning symbol"
            />
          </li>
          <li
            onClick={() => {
              setOpenCart(true);
            }}
            className="nav-list__item nav-cart"
          >
            cart ({cartQty})
          </li>
        </ul>
      </nav>
      {openCart && (
        <Cart
          closeCart={setOpenCart}
          products={products}
          cartItems={cartItems}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
        />
      )}
    </>
  );
}

export default Nav;
